var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('v-container',{attrs:{"id":"widget-area--hero-zone","fluid":""}},[_c('v-row',{attrs:{"column":"","justify-center":"","align-center":"","no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }